<div class="trustees-container px-4 py-3">

  <!-- Page Header -->
  <div class="mb-3">
    <p class="fw-bold mb-1 text-xl">Beneficiary Register</p>
    <p class="text-dark mb-0 text-x">
      View-only access to the trust beneficiary register.
    </p>
  </div>

  <!-- Summary Cards -->
  <div class="row g-4 mb-4">
    <div
      v-for="stat in stats"
      :key="stat.label"
      class="col-md-3"
    >
      <div class="glassy-table shadow-sm border-0 rounded-lg p-3 h-100">
        <p class="text-dark small mb-2">{{ stat.label }}</p>
        <h3 class="fw-bold mb-1" :class="stat.colorClass">
          {{ stat.value }}
        </h3>
      </div>
    </div>
  </div>

  <!-- Search + Filter Row -->
  <div class="row align-items-center mb-4 g-3">

    <!-- Search -->
    <div class="col-md-8">
        <div class="input-group input-group-sm">
            <span class="input-group-text border-0">
            <i class="bi bi-search text-muted"></i>
            </span>
            <input
            type="text"
            class="form-control border-0 glassy-bg shadow-sm text-dark"
            placeholder="Search beneficiaries..."
            />
        </div>
    </div>


    <!-- Filters -->
    <div class="col-md-4 text-md-end">
      <div class="btn-group bg-light rounded">
        <button
          v-for="tab in ['All', 'Active', 'Inactive', 'Pending']"
          :key="tab"
          class="btn text-xs"
          :class="{ active: activeTab === tab }"
          @click="activeTab = tab"
        >
          {{ tab }}
        </button>
      </div>
    </div>

  </div>

  <!-- Beneficiaries Table Card -->
  <div class="glassy-table shadow-sm border-0 rounded-lg p-4">

    <div class="mb-3">
      <p class="text-dark text-xs fw-500 mb-0">
        Registered beneficiaries and allocation details
      </p>
    </div>

    <!-- Table Header -->
    <div class="row text-dark small border-bottom border-dark pb-2 mb-3 fw-semibold">
      <div class="col-md-3">Name</div>
      <div class="col-md-2">ID Number</div>
      <div class="col-md-1">Start Date</div>
      <div class="col-md-1">Status</div>
      <div class="col-md-1">KYC</div>
      <div class="col-md-1 text-end">Allocation</div>
      <div class="col-md-2 text-end">Distributed</div>
      <div class="col-md-1"></div>
    </div>

    <!-- Rows -->
    <div
      v-for="person in beneficiaries"
      :key="person.id"
      class="row align-items-center py-3 border-bottom"
    >

      <!-- Name -->
      <div class="col-md-3 d-flex align-items-center small">
        <div class="avatar-circle me-3">
          {{ person.initials }}
        </div>
        <div>
          <div class="fw-semibold">{{ person.name }}</div>
        </div>
      </div>

      <!-- ID -->
      <div class="col-md-2 small">
        {{ person.idNumber }}
      </div>

      <!-- Start Date -->
      <div class="col-md-1 small">
        {{ person.startDate }}
      </div>

      <!-- Status -->
      <div class="col-md-1">
        <span
          class="badge rounded-pill px-3 py-2"
          :class="{
            'bg-success-subtle text-success': person.status === 'Active',
            'bg-secondary-subtle text-secondary': person.status === 'Inactive',
            'bg-warning-subtle text-warning': person.status === 'Pending'
          }"
        >
          {{ person.status }}
        </span>
      </div>

      <!-- KYC -->
      <div class="col-md-1 small fw-semibold"
           :class="{
             'text-success': person.kyc === 'Approved',
             'text-warning': person.kyc === 'Pending',
             'text-danger': person.kyc === 'Rejected'
           }"
      >
        {{ person.kyc }}
      </div>

      <!-- Allocation -->
      <div class="col-md-1 text-end small fw-semibold">
        {{ person.allocation }}%
      </div>

      <!-- Distributed -->
      <div class="col-md-2 text-end small fw-semibold">
        R {{ person.distributed.toLocaleString() }}
      </div>

      <!-- Actions -->
      <div class="col-md-1 text-end">
        <i class="bx bx-dots-horizontal-rounded fs-5 text-muted cursor-pointer"></i>
      </div>

    </div>

  </div>

</div>
